import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import TongueWebPiercingImage from '../../Assets/Piercing Services/tongue web piercing (2).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function TongueWebPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Tongue Web Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Tongue Web Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Tongue Web Piercing 250 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={TongueWebPiercingImage} alt="Tongue Web Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Tongue Web Piercing</h3>

          <p>
            Discover a subtle yet unique way to express your individuality with our professional tongue web piercing services in the UAE, available at an affordable price of 250 AED. Tongue web piercing, also known as frenulum piercing, is a discreet oral piercing located beneath the tongue on the thin tissue that connects the tongue to the floor of the mouth. This hidden yet stylish piercing is perfect for individuals who want something different without being overly visible, offering a balance between personal expression and subtle elegance. Its placement allows you to reveal it only when you choose, making it a popular option for those who prefer a low-key yet trendy look.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each tongue web piercing with precision and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Oral piercings require expert handling due to the sensitivity of the area, and our experienced specialists are trained to perform the procedure accurately while minimizing discomfort and ensuring proper placement.
          </p>

          <p>
            Tongue web piercing is ideal for individuals who want a unique and unconventional style that stands out in a subtle way. Unlike more visible piercings, this placement offers a hidden aesthetic that can be revealed when desired, adding a sense of exclusivity and personal flair. It is typically adorned with a small curved barbell or ring, providing a comfortable fit while maintaining a stylish appearance. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry options to suit your comfort and style.
          </p>

          <p>
            The procedure is typically completed within minutes, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support efficient healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that oral piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is a crucial part of maintaining your tongue web piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, oral hygiene practices, and precautions such as avoiding certain foods, smoking, or alcohol during the healing period. Following proper aftercare ensures faster healing and helps maintain the health and appearance of your piercing.
          </p>

          <p>
            Our tongue web piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted tongue web piercing services in the UAE for a safe, hygienic, and professional experience. With experienced specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a unique and subtle look effortlessly. Book your tongue web piercing appointment today and express your individuality with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Tongue Web Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default TongueWebPiercing;